import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=7f542ea0&scoped=true&"
import script from "./Explanation.vue?vue&type=script&lang=js&"
export * from "./Explanation.vue?vue&type=script&lang=js&"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=7f542ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f542ea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f542ea0')) {
      api.createRecord('7f542ea0', component.options)
    } else {
      api.reload('7f542ea0', component.options)
    }
    module.hot.accept("./Explanation.vue?vue&type=template&id=7f542ea0&scoped=true&", function () {
      api.rerender('7f542ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/comp/Explanation.vue"
export default component.exports